var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card-item checkin-content" }, [
      _c(
        "div",
        { staticClass: "card-content", attrs: { id: "checkin-welcome" } },
        [
          _c(
            "b-steps",
            {
              attrs: {
                animated: _vm.isAnimated,
                rounded: _vm.isRounded,
                "has-navigation": _vm.hasNavigation,
                "icon-prev": _vm.prevIcon,
                "icon-next": _vm.nextIcon,
                "label-position": _vm.labelPosition,
                "mobile-mode": _vm.mobileMode,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "navigation",
                    fn: function ({ previous, next }) {
                      return _vm.customNavigation
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "button-navigation-checkin columns is-mobile",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "column has-text-left" },
                                  [
                                    _vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    _vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !previous.disabled,
                                                expression:
                                                  "!previous.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              rounded: "",
                                              "icon-pack": "fas",
                                              "icon-left": "angle-left",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress -= 50
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return previous.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Atrás ")]
                                        )
                                      : _vm._e(),
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    _vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !previous.disabled,
                                                expression:
                                                  "!previous.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              "icon-pack": "fas",
                                              "icon-left": "angle-left",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress -= 100
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return previous.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Atrás ")]
                                        )
                                      : _vm._e(),
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !previous.disabled,
                                                expression:
                                                  "!previous.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              "icon-pack": "fas",
                                              "icon-left": "angle-left",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress -= 100
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return previous.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Atrás ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    _vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    _vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !next.disabled,
                                                expression: "!next.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              rounded: "",
                                              "icon-pack": "fas",
                                              "icon-right": "angle-right",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress += 50
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return next.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Siguiente ")]
                                        )
                                      : _vm._e(),
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    _vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !next.disabled,
                                                expression: "!next.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              "icon-pack": "fas",
                                              "icon-right": "angle-right",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress += 100
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return next.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Siguiente ")]
                                        )
                                      : _vm._e(),
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .paymentByAndes &&
                                    !_vm.$store.state.currentUser.user.checkIn
                                      .knowAndes
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !next.disabled,
                                                expression: "!next.disabled",
                                              },
                                            ],
                                            staticClass: "is-white step",
                                            attrs: {
                                              "icon-pack": "fas",
                                              "icon-right": "angle-right",
                                            },
                                            on: {
                                              click: [
                                                function ($event) {
                                                  _vm.progress += 100
                                                },
                                                function ($event) {
                                                  $event.preventDefault()
                                                  return next.action.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [_vm._v(" Siguiente ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        : undefined
                    },
                  },
                ],
                null,
                true
              ),
              model: {
                value: _vm.activeStep,
                callback: function ($$v) {
                  _vm.activeStep = $$v
                },
                expression: "activeStep",
              },
            },
            [
              _c(
                "b-step-item",
                { attrs: { clickable: _vm.isStepsClickable } },
                [
                  _c(
                    "div",
                    { staticClass: "columns is-desktop is-vcentered" },
                    [
                      _c("div", { staticClass: "image-check-in column py-0" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/ui/assets/img/questions1.svg"),
                            alt: "seguridad",
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-content column is-three-quarters-desktop",
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              "¿Qué es el check-in y qué estoy aceptando?"
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " El check-in es el momento donde conoces y aceptas las condiciones y servicios de nuestro nuevo sitio privado en creditu.com. "
                            ),
                          ]),
                          _c("p", { staticStyle: { "margin-top": "1em" } }, [
                            _vm._v("Cuando realices tu check-in "),
                            _c("strong", [_vm._v("aceptas a:")]),
                          ]),
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                "list-style-type": "disc",
                                "padding-left": "1.5em",
                              },
                            },
                            [
                              _c("li", [
                                _vm._v(" Utilizar "),
                                _c("strong", [
                                  _vm._v("nuestra plataforma de pago"),
                                ]),
                                _vm._v(", apenas tu cuota esté disponible. "),
                              ]),
                              _c("li", [
                                _vm._v("Recibir "),
                                _c("strong", [
                                  _vm._v("nuestros servicios de atención"),
                                ]),
                                _vm._v(" al cliente."),
                              ]),
                            ]
                          ),
                          _c("p", { staticStyle: { "margin-top": "1em" } }, [
                            _vm._v("✨ Todo en un mismo lugar."),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm.$store.state.currentUser.user.checkIn.paymentByAndes
                ? _c(
                    "b-step-item",
                    {
                      attrs: {
                        clickable: _vm.isStepsClickable,
                        type: "is-success",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "columns is-desktop is-vcentered" },
                        [
                          _c(
                            "div",
                            { staticClass: "image-check-in column py-0" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/ui/assets/img/question2.svg"),
                                  alt: "seguridad",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-content column is-three-quarters-desktop",
                            },
                            [
                              _c("h3", [
                                _vm._v(
                                  "¿Podré volver a pagar por Administradora Andes?"
                                ),
                              ]),
                              _c("p", [
                                _vm._v(" Al realizar tu check-in y "),
                                _c("strong", [
                                  _vm._v("después que confirmemos"),
                                ]),
                                _vm._v(
                                  " que tu información fue actualizada a nuestro sistema Creditú, tus dividendos no podrán ser pagados en Andes. "
                                ),
                              ]),
                              _c("p", [
                                _vm._v(
                                  " Recibirás una notificación con toda la información. "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "b-step-item",
                { attrs: { clickable: _vm.isStepsClickable, disabled: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "columns is-vcentered is-desktop" },
                    [
                      _c("div", { staticClass: "image-check-in column py-0" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/ui/assets/img/question4.svg"),
                            alt: "seguridad",
                          },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-content column is-three-quarters-desktop",
                        },
                        [
                          _c("h3", [
                            _vm._v(
                              "¿Cuáles medios de pago tendré disponible en Creditú?"
                            ),
                          ]),
                          _c("p", [
                            _vm._v(
                              " Podrás pagar tu dividendo dentro de tu sitio privado 100% online con los siguientes medios de pago: "
                            ),
                          ]),
                          _c("div", { staticClass: "columns is-centered" }, [
                            _c(
                              "div",
                              {
                                staticClass: "column is-one-quarter-desktop",
                                attrs: { id: "payment-method" },
                              },
                              [
                                _c("div", { staticClass: "payment-icon" }, [
                                  _c("i", { staticClass: "fas fa-university" }),
                                ]),
                                _c("p", [
                                  _c("span", { staticClass: "payment-label" }, [
                                    _vm._v("Transferencia bancaria"),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "column is-one-quarter-desktop",
                                attrs: { id: "payment-method" },
                              },
                              [
                                _c("div", { staticClass: "payment-icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-credit-card",
                                  }),
                                ]),
                                _c("p", [
                                  _c("span", { staticClass: "payment-label" }, [
                                    _vm._v("Servipag"),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "column is-one-quarter-desktop",
                                attrs: { id: "payment-method" },
                              },
                              [
                                _c("div", { staticClass: "payment-icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-money-bill-wave",
                                  }),
                                ]),
                                _c("p", [
                                  _c("span", { staticClass: "payment-label" }, [
                                    _vm._v("Depósito en efectivo"),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "column is-one-quarter-desktop",
                                attrs: { id: "payment-method" },
                              },
                              [
                                _c("div", { staticClass: "payment-icon" }, [
                                  _c("img", {
                                    staticClass: "img-gray",
                                    attrs: {
                                      alt: "neat logo",
                                      src: require("@/ui/assets/img/neat.svg"),
                                    },
                                  }),
                                ]),
                                _c("p", [
                                  _c("span", { staticClass: "payment-label" }, [
                                    _vm._v("Neat Pagos"),
                                  ]),
                                ]),
                                _c("p", [
                                  _c(
                                    "span",
                                    { staticClass: "pay-method-sub font-size" },
                                    [_vm._v("(Tarjeta de crédito)")]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "progress-bar" },
        [
          _c("b-progress", {
            attrs: {
              size: "is-small",
              type: "is-primary",
              value: _vm.progress,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "confirmed-term" }, [
        _c("div", { staticClass: "button-content left transition-slow" }),
        _c("div", { staticClass: "button-content transition-slow" }, [
          _vm.$store.state.currentUser.user.checkIn.paymentByAndes &&
          _vm.$store.state.currentUser.user.checkIn.knowAndes
            ? _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: {
                    id: "continueButton",
                    disabled: !(_vm.activeStep === 2),
                  },
                  on: { click: _vm.confirmCustom },
                },
                [_vm._v(" Estoy de acuerdo ")]
              )
            : _vm._e(),
          !_vm.$store.state.currentUser.user.checkIn.paymentByAndes &&
          _vm.$store.state.currentUser.user.checkIn.knowAndes
            ? _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: {
                    id: "continueButton",
                    disabled: !(_vm.activeStep === 1),
                  },
                  on: { click: _vm.confirmCustom },
                },
                [_vm._v(" Estoy de acuerdo ")]
              )
            : _vm._e(),
          !_vm.$store.state.currentUser.user.checkIn.paymentByAndes &&
          !_vm.$store.state.currentUser.user.checkIn.knowAndes
            ? _c(
                "button",
                {
                  staticClass: "button is-button-primary is-rounded",
                  attrs: {
                    id: "continueButton",
                    disabled: !(_vm.activeStep === 1),
                  },
                  on: { click: _vm.confirmCustom },
                },
                [_vm._v(" Estoy de acuerdo ")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }